/**
 * Out of Network Result Component
 *
 * Shows when insurance is out-of-network with the practice
 * Allows user to try another insurance or continue without
 */

"use client";

import { Button } from "@frontend/shared/components/ui/button";
import { motion } from "framer-motion";
import Image from "next/image";
import { useTranslations } from "@frontend/lib/next-intl-typed";
import {
  useInsuranceConnectorSend,
  useInsuranceConnectorState,
} from "../insurance-connector-provider";

interface OutOfNetworkResultProps {
  isMobile?: boolean;
}

export const OutOfNetworkResult = ({
  isMobile = false,
}: OutOfNetworkResultProps) => {
  const state = useInsuranceConnectorState();
  const send = useInsuranceConnectorSend();
  const t = useTranslations("InsuranceConnector");

  const orgName = state.context.orgName || t("ThisPractice");
  const primaryPayer =
    state.context.primaryInsurance?.payer || t("YourInsuranceFallback");

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      className={`rounded-3xl ${isMobile ? "w-full p-4" : "w-96 p-6"}`}
    >
      <div className="flex flex-col gap-6">
        <div className="flex flex-row justify-between items-start gap-2">
          <p className="text-2xl font-semibold">
            {t("OutOfNetworkMessage", { primaryPayer, orgName })}
          </p>
          <Image
            src="/images/kiosk/ActiveOON.svg"
            alt={t("OutOfNetworkAlt")}
            width={50}
            height={24}
          />
        </div>
        <p className="text-lg">{t("WhatWouldYouLikeToDo")}</p>
        <div className="flex gap-2">
          <Button
            onClick={() => send({ type: "CONTINUE_WITHOUT_INSURANCE" })}
            variant="outline"
            className="h-12 w-full rounded-full text-lg"
          >
            {t("ContinueWithoutIt")}
          </Button>
          <Button
            onClick={() => send({ type: "TRY_ANOTHER" })}
            className="h-12 w-full rounded-full text-lg"
          >
            {t("TryAnother")}
          </Button>
        </div>
      </div>
    </motion.div>
  );
};
